<app-card>
  <div class="header">
    <h3>{{ "rules.rules" | translate }}</h3>
    <button
      type="button"
      class="button primary-button icon-button"
      [disabled]="disabled"
      (click)="createRule.emit()"
    >
      <app-icon name="ic_plus" />
      {{ "rules.new" | translate }}
    </button>
  </div>
  <div class="rule-wrapper content">
    @for (rule of rules; track rule.id) {
      <app-rule-list-item [rule]="rule" />
    } @empty {
      <p class="paragraph">{{ "rules.empty.text" | translate }}</p>
    }
  </div>
</app-card>
